import {useParams} from "react-router-dom";
import {usePublicInformationController} from "../../controllers/publicInfo-controller";
import {PageHeader} from "@ant-design/pro-layout";
import {navigateBackHandler} from "../../helpers/mainHelpers";
import React, {useEffect} from "react";
import "./style.less"
import {useDevice} from "../../context/deviceContext";
import {Spin} from "antd";

const PublicInformationItemPage = () => {
  const {publicInfoId} = useParams()
  const {isMobile} = useDevice()
  const {isLoading, selectedPublicInfoItem, getPublicInfoItemData} = usePublicInformationController()

  useEffect(() => {
    if (publicInfoId) {
      getPublicInfoItemData(publicInfoId)
    }
  }, [publicInfoId])

  const downloadButtonHandler = () => {
  }

  // const downloadButtonTitle = isMobile ? undefined : "Завантажити"

  return <>
    <div className="page_title">
      <PageHeader
        // extra={[<SuccessButton onClick={downloadButtonHandler} icon={<DownloadOutlined/>} children={downloadButtonTitle}
        //                        type={"default"}/>]}
        title={
          <div className="page-header_title">
            <div className="page_name">
              {selectedPublicInfoItem?.title}
            </div>
          </div>
        }
        onBack={navigateBackHandler}
      />
    </div>
    <div className='page_content'>

      <div className="publicItemPage_body">

        {selectedPublicInfoItem?.fileLink ? (
          <iframe
            className="publicFileView_iframe"
            src={selectedPublicInfoItem.fileLink}
            title="Public Info Document"
          />
        ) : (
          <Spin spinning={isLoading}/>
        )}

      </div>

    </div>
  </>
}
export default PublicInformationItemPage